import { Theme, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        primary: {
          boxShadow: 'none',
          color: theme.palette.buttonPrimary.text,
          border: `2px solid ${theme.palette.buttonPrimary.background}`,
          backgroundColor: theme.palette.buttonPrimary.background,
          '&:hover': {
            color: theme.palette.buttonPrimary.text,
            border: theme.palette.actionBlue.hover,
            backgroundColor: theme.palette.actionBlue.hover,
          },
          '&.Mui-disabled': {
            color: theme.palette.buttonPrimary.text,
            border: theme.palette.actionBlue.disabled,
            backgroundColor: theme.palette.actionBlue.disabled,
          }
        },
        secondary: {
          boxShadow: 'none',
          color: theme.palette.buttonSecondary.text,
          border: `2px solid ${theme.palette.buttonSecondary.stroke}`,
          backgroundColor: theme.palette.buttonSecondary.background,
          '&:hover': {
            color: theme.palette.actionBlue.hover,
            border: `2px solid ${theme.palette.actionBlue.hover}`,
            backgroundColor: theme.palette.buttonSecondary.background,
          },
          '&.Mui-disabled': {
            color: theme.palette.action.disabled,
            border: `2px solid ${theme.palette.action.disabled}`,
            backgroundColor: theme.palette.buttonSecondary.background
          }
        },
        tertiary: {
          boxShadow: 'none',
          color: theme.palette.buttonTertiary.text,
          border: `2px solid ${theme.palette.buttonTertiary.background}`,
          backgroundColor: theme.palette.buttonTertiary.background,
          '&:hover': {
            color: theme.palette.buttonTertiary.text,
            border: `2px solid ${theme.palette.actionPurple.hover}`,
            backgroundColor: theme.palette.actionPurple.hover,
          },
          '&.Mui-disabled': {
            color: theme.palette.buttonPrimary.text,
            border: `2px solid ${theme.palette.actionPurple.disabled}`,
            backgroundColor: theme.palette.actionPurple.disabled,
          }
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        containedInfo: {
          boxShadow: theme.customShadows.info,
        },
        containedSuccess: {
          boxShadow: theme.customShadows.success,
        },
        containedWarning: {
          boxShadow: theme.customShadows.warning,
        },
        containedError: {
          boxShadow: theme.customShadows.error,
        },
        // outlined
        outlinedInherit: {
          border: `2px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.actionBlue.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.actionBlue.hover,
          },
        },
      },
    },
  };
}
